export function UserGroupForUserCtrl ($scope, $uibModalInstance, $translate, messages, sessionObjAPI, workshopAPI, user, userGroups, idx) {

  $scope.user = user;
  $scope.userGroups = userGroups;
  $scope.idx = idx;

  $scope.save = function (form) {
    workshopAPI.patch('/workshop_admin/update_group_for_user', user, 'user')
      .then(function () {
        $uibModalInstance.close();
        messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.USER_GROUP'), 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.cancel = $uibModalInstance.dismiss;
}